import * as Config from '../config';
import useDebouncedEffect from './useDebouncedEffect';
import { useState, useEffect, useCallback, useContext } from "react";
import { ReactReduxContext } from 'react-redux';

import {
  setStackAutomix
} from "../components/library/automix/redux/actions/index";

import {
  setSelectedItems, setReadyBoostFilters,
  setStoreListRedux, updateStorePlaylists
} from "../actions/index";

const axios = require('axios');

const NB_ITEMS_BY_DEBOUNCE = 10; //10 items / 20fps / 50ms
let globalStackItems = [];
let locked = false;
let globalNext = null;
const defaultStoreList = {
  itemsFull: null,
  total: 0,
  items: null,
  count: 0,
  next: null
}
const useApiOrLocalV2 = ( 
  api, path = null, data = [], idParent, from = null, isBoost = false, createStore = false, 
  isBaseRootApi = true, customFormatData = null, loadMoreWithApi = true) => {
  const { store } = useContext(ReactReduxContext)
  const { getState, dispatch } = store;
  const [storeList, setStoreList] = useState(defaultStoreList);

  useEffect(() => {
    if (storeList.total > 0) {
      setStoreList(defaultStoreList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]) // Warning - storeList.total but need to be removed

  useEffect(() => {
    let source = null;
    unSelectedItems();
    if (path) {
      // if (!locked) {
        // locked = true;
        if (path.includes('LOCAL|')) { // No request again if local order by | Filters
          const partx = path.replace(`LOCAL|`, ``).split(`&`);
          let order = ``;
          const filters = partx.reduce( (base, x) => {
            if (x.length > 0 && !x.includes(`order_by`)) {
              const [type, value] = x.split(`=`);
              base.push({type, value});
            } else if (x.length > 0 && x.includes(`order_by`)) {
              const [, valueo] = x.split(`=`);
              order = valueo;
            }
            return base;
          }, []);

          const asc = order.includes('-') ? false : true ;
          const property = order.includes('-') ? order.substring(1, order.length) : order;

          if (storeList.itemsFull.length > 0) {
            let newItems = [...storeList.itemsFull].filter( x => filters.every( f => {
              const strict = (f.type === `key_camelot` || f.type === `genre_s`);
              return x[f.type] && x[f.type].toLowerCase().slice(0, strict ? f.value.length : x[f.type].length ).includes(f.value.toLowerCase())
            } ));
            if (property === `key_camelot`) {
              newItems.sort(Config.sortAlphaNumeric(property, asc));
            } else if (property === `bpm`) {
              newItems.sort(Config.sortNumeric(property, asc));
            } else {
              newItems.sort(Config.sortAlpha(property, asc));
            }
            const ii = [...newItems].splice(0, NB_ITEMS_BY_DEBOUNCE);
            setStoreList({
              ...storeList,
              items: [...ii],
              count: NB_ITEMS_BY_DEBOUNCE
            })
            globalStackItems[idParent] = newItems;

            if (from) {
              dispatch(setStackAutomix({ idPlaylist: idParent, tracks: [...newItems], from, active: 0, next: null }));
            }
          }
        } else {

          source = axios.CancelToken.source();
          const isCache = (!path.includes('/my/playlists') && !path.includes('/my/beatport/tracks') && !path.includes('/my/default-cart')); // TODO - PROPS
          api.getFromApi(path, isCache, source.token, isBaseRootApi ? Config.API_URL : Config.API_SEARCH_URL).then( (response) => {
            let dataResults = null;

            if (path.includes('tracks') && !isBaseRootApi) {
              dataResults = response.data.data;
            } else if ((path.includes('/catalog/search/') && path.includes('tracks')) || (path.includes('/my/default-cart/'))) {
              dataResults = response.data.tracks;
            } else {
              dataResults = (path.includes('/my/playlists')) ? response.data.results.map( x => { x.track.item_id = x.id; x.track.tombstoned = (x.tombstoned) ? x.tombstoned : null; return x.track } ) : response.data.results;
            }

            //V1
            // const dataResultsFormatted = dataResults.map(isBaseRootApi ? Config.formattedFromBP: Config.formattedFromSearchV1).map(Config.rankingByPage(parseInt(response.data.page), parseInt(response.data.per_page)));
            // V2
            let dataResultsFormatted = customFormatData ? customFormatData(dataResults) : dataResults.map(isBaseRootApi ? Config.formattedFromBP: Config.formattedFromSearchV1);
            dataResultsFormatted = dataResultsFormatted.map(Config.rankingByPage(parseInt(response.data.page), parseInt(response.data.per_page)));

            const dataSpliced = [...dataResultsFormatted].splice(0, NB_ITEMS_BY_DEBOUNCE);
            globalStackItems[idParent] = dataResultsFormatted; // IMPORTANT - NEVER RE-RENDER
            // locked = false;

            let next = response.data.next;
            if (!loadMoreWithApi && response.data.page && next) {
              const page = parseInt(response.data.page.split('/')[0]) + 1;
              if (page) {
                next = Config.API_URL + path + `&page=${page}`;
              }
            }

            setStoreList({
              itemsFull: dataResultsFormatted,
              total: dataResultsFormatted.length,
              items: [...dataSpliced],
              count: NB_ITEMS_BY_DEBOUNCE,
              next: next
            });
            globalNext = next;

            if (from) {
              dispatch(setStackAutomix({ idPlaylist: idParent, tracks: dataResultsFormatted.filter(x => !x.tombstoned).map( x => { /*x.from = from;*/ return x } ), from, active: 0, next: globalNext }));
            }
            dispatch(setReadyBoostFilters( isBoost ? !!!response.data.next : true));

          })
          .catch( e => {
            if (e.constructor.name !== 'Cancel' && e.constructor.name !== 'r') {
              console.log('useApiOrLocal error', path, e, e.constructor.name); // todo - remove 
              // store.getState().storeAuth.logout(); // REMOVE FOR NOW
            }
          } );

        }
      // }
    } else if (data) {
      const dataResultsFormatted = data.map((idParent === `search`) ? Config.formattedFromBP : Config.formatted);
      const dataSpliced = [...dataResultsFormatted].splice(0, NB_ITEMS_BY_DEBOUNCE);
      globalStackItems[idParent] = dataResultsFormatted; // IMPORTANT - NEVER RE-RENDER
      setStoreList({
        itemsFull: dataResultsFormatted,
        total: dataResultsFormatted.length,
        items: [...dataSpliced],
        count: NB_ITEMS_BY_DEBOUNCE,
        next: null
      });
    }

    return () => { source && source.cancel() } // Clean Axios

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, path, data, idParent, from, dispatch]); //warning storeList

  // EVERY ~20/30 frames
  useDebouncedEffect( () => {
    if (storeList.items && storeList.count < storeList.total && globalStackItems[idParent]) {
      const ii = [...globalStackItems[idParent]].splice(storeList.count, NB_ITEMS_BY_DEBOUNCE);
      setStoreList({
        ...storeList,
        items: [...storeList.items, ...ii],
        count: storeList.count + NB_ITEMS_BY_DEBOUNCE
      })
    }

    if (isBoost && storeList.total - storeList.count <= 10) { // IF BOOST AND ONLY MY PLAYLIST
      onLoadMore(storeList.count)();
    }

  }, (storeList.count < storeList.total) ? 50 : 3600000, [storeList])
  // 1000 / fps

  // Touch Mode - Double Tap or Normal Click
  const onClickItem = useCallback((item, e, index = null, touch = false) => {
    if (store.getState().allowAccess) {
      let itemx = [...globalStackItems[idParent]];
      if (e.drag) {
        index = index ?? itemx.findIndex( x => x.id === item.id)
        itemx[index].selected = true;
      } else if (e.clear) {
        itemx.forEach( x => { x.selected = false; return x } )
      }  else if (e.shiftKey) {
        index = index ?? itemx.findIndex( x => x.id === item.id)
        const lastSelected = itemx.filter(x => x.selected).pop();
        const lastIDSelected = (lastSelected) ? lastSelected.id : item.id;
        const lastIndexSelected = itemx.findIndex( x => x.id === lastIDSelected);
        if (lastIndexSelected <= index) {
          itemx.forEach( (x,i) => { if ( lastIndexSelected <= i && i <= index) x.selected = true } )
        } else {
          itemx.forEach( (x,i) => { if (i <= lastIndexSelected && index <= i) x.selected = true } )
        }
      } else if (e.altKey || e.metaKey || touch) {
        index = index ?? itemx.findIndex( x => x.id === item.id)
        itemx[index].selected = !itemx[index].selected;
      } else {
        index = index ?? itemx.findIndex( x => x.id === item.id);
        itemx.forEach( (x,i) => {
          x.selected = (index === i);
          x.listParentId = idParent; // For Multiple Columns - Arrows Manager
          return x;
        } )
      }
      dispatch(setSelectedItems([...itemx.filter( x => x.selected )]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParent, dispatch]);

  const allSelectedItems = useCallback(() => {
    let itemx = [...globalStackItems[idParent]];
    const aAll = [...itemx.map(x => { x.selected = true; return x })];
    dispatch(setSelectedItems(aAll));
  }, [idParent, dispatch]);

  const unSelectedItems = useCallback(() => {
    if (!store.getState().touchEditor) { // Blur basic behavior
      dispatch(setSelectedItems([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParent, dispatch]);

  const end = useCallback(() => { // Only Drop Exterior or Escape

    // In case the drag start before the selection
    const state = getState();
    const selectedItems = state.selectedItems;
    selectedItems.forEach( x => {
      if (!x.selected) {
        const el = document.getElementById(`DI-${x.id}-TRACK`);
        if (el && el.classList.value.includes(`selected`)) {
          el.classList.remove(`selected`);
        }
      }
    })

    unSelectedItems();
  }, [unSelectedItems, getState])

  const forceUpdate = (newData) => {
    let itemx = [...globalStackItems[idParent].map( x => {
      const newItem = newData.find( y => y.track_id === x.id )
      if (newItem) {
        x.item_id = newItem.item_id
      }
      return x;
    })];
    globalStackItems[idParent] = itemx;
  }

  const onDropSortable = useCallback(( source, endIndex, afterSortable = () => {}) => (item) => {
    const state = getState();
    let selectedItems = state.selectedItems;

    let newItems = [];
    let newItemsForParent = [];
    if (source === item.idParent) { //SAME PARENT
      if (selectedItems.length === 1) {
        const startIndex = globalStackItems[idParent].findIndex(x => x.id === item.id);
        newItems = Config.reorder(globalStackItems[idParent].map(x => { x.selected = false; return x }), startIndex, endIndex); // JUST ONE ELEMENT
      } else {
        let itemReference = globalStackItems[idParent].find((x,i) => i === endIndex + 1);
        const idsAvailable = selectedItems.map( x => x.id );
        newItems = globalStackItems[idParent].reduce( (b, x) => {
          if (!idsAvailable.includes(x.id)) { b.push(x) }
          return b;
        }, []);
        const startIndex = (itemReference) ? newItems.findIndex(x => x.id === itemReference.id) : newItems.length;
        newItems.splice(startIndex, 0, ...selectedItems.map(x => { x.selected = false; return x }));
      }
    } else { // DIFFERENT PARENT
      selectedItems = state.dragItems;
      newItemsForParent = selectedItems.map( x => x.id );
      newItems = [...globalStackItems[idParent]];
      newItems.splice(endIndex + 1, 0, ...selectedItems.map(x => { x.selected = false; return x })); //newItems.splice(endIndex + 1, 0, item);
    }

    globalStackItems[idParent] = newItems;
    setStoreList({
      ...storeList,
      itemsFull: [...newItems],
      total: newItems.length,
      items: [...newItems],
      count: newItems.length
    });

    afterSortable([...newItems], newItemsForParent, `update`, forceUpdate); //For parent like playlists, it will update the actual list but need to change the root
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParent]);

  // Touch - Move TOP OR BOTTOM
  const moveSortable = useCallback((top = true) => {
    const state = getState();
    const selectedItems = state.selectedItems;

    let newItems = [];
    const idsAvailable = selectedItems.map( x => x.id );
    newItems = globalStackItems[idParent].reduce( (b, x) => {
      if (!idsAvailable.includes(x.id)) { b.push(x) }
      return b;
    }, []);
    const startIndex = (top) ? 0 : newItems.length;
    newItems.splice(startIndex, 0, ...selectedItems.map(x => { x.selected = false; return x }));

    globalStackItems[idParent] = newItems;
    setStoreList({
      ...storeList,
      itemsFull: [...newItems],
      total: newItems.length,
      items: [...newItems],
      count: newItems.length
    });

    api.patch(`/my/playlists/${idParent}/tracks/bulk/`, { items: newItems.map((x,i) => ({ item_id: x.item_id, position: i + 1 })) }); // API
    dispatch(updateStorePlaylists(idParent, `tracks`, newItems)); //Local

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, idParent, dispatch]);

  const onLoadMore = useCallback((index) => () => {
    let itemx = (globalStackItems[idParent]) ? [...globalStackItems[idParent]] : [];
    if (!locked && globalNext) {
      if (index >= (itemx.length - (NB_ITEMS_BY_DEBOUNCE * 3) )) {
        locked = true;
        if (api && globalNext) {
          const nextPromise = (globalNext.includes('https')) ? api.getFromURL(globalNext) : api.getFromURI(globalNext);

          nextPromise.then( (response) => {
            let dataResults = null;
            if (globalNext.includes('/catalog/search/') && globalNext.includes('tracks')) {
              dataResults = response.data.tracks;
            } else {
              dataResults = (globalNext && globalNext.includes('/my/playlists')) ? response.data.results.map( x => { x.track.item_id = x.id; return x.track } ) : response.data.results;
            }
            const dataResultsFormatted = [...itemx, ...dataResults.map(Config.formattedFromBP)]
            globalStackItems[idParent] = dataResultsFormatted;

            let next = response.data.next;
            if (!loadMoreWithApi && response.data.page && next) {
              const page = parseInt(response.data.page.split('/')[0]) + 1;
              if (page) {
                next = Config.API_URL + path + `&page=${page}`;
              }
            }

            setStoreList({
              itemsFull: dataResultsFormatted,
              total: dataResultsFormatted.length,
              items: [...itemx],
              count: itemx.length,
              next: next
            });
            globalNext = next;
            locked = false;

            if (from) {
              dispatch(setStackAutomix({ idPlaylist: idParent, tracks: [...dataResultsFormatted], from, active: 0, next: null }));
            }

            dispatch(setReadyBoostFilters( isBoost ? !!!response.data.next : true));
          })
          .catch( e => console.log(`error - useApiOrLocal`, e) );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParent, api, isBoost, from, dispatch, path]);

  const onDeleteItem = useCallback((index, afterDelete = null) => {
    let itemx = [...globalStackItems[idParent]];
    const item_id = itemx[index].item_id;
    itemx.splice(index, 1);
    globalStackItems[idParent] = itemx;
    setStoreList({
      itemsFull: [...itemx],
      total: itemx.length,
      items: [...itemx.map(x => { x.selected = false; return x })],
      count: itemx.length,
      next: null
    });
    if (afterDelete) {
      afterDelete([...itemx.map(x => { x.selected = false; return x })], [item_id], 'delete');
    }    
  }, [idParent]);

  const onMassDelete = useCallback((ids, item_ids, afterDelete = null) => {
    let itemx = [...globalStackItems[idParent]];
    ids.forEach( id => {
      const index = itemx.findIndex( x => x.id === id )
      if (index >= 0) {
        itemx.splice(index, 1);
      }
    })
    globalStackItems[idParent] = itemx;
    setStoreList(stack => ({
      ...stack,
      itemsFull: [...itemx],
      total: itemx.length,
      items: [...itemx.map(x => { x.selected = false; return x })],
      count: itemx.length
    }));
    if (afterDelete) {
      afterDelete([...itemx.map(x => { x.selected = false; return x })], item_ids);
    }
  }, [idParent]);

  const storeX = {
    storeList,
    onClickItem,
    end,
    unSelectedItems,
    onDropSortable,
    onDeleteItem,
    onMassDelete,
    onLoadMore,
    allSelectedItems,
    moveSortable
  };

  if (createStore) { setTimeout(() => { dispatch(setStoreListRedux(storeX)) }, 100);  }

  return storeX;

};

export default useApiOrLocalV2;
